import * as fromDatatype from '../datatype-library/index';

export interface bl_cpcommerce_form_answer_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  form_field_set_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeClass;
  value_boolean: boolean;
  tpy_sync_switch: boolean;
	value_datetime: fromDatatype.TimestampTzDatatypeInterface;
	value_json: fromDatatype.JsonDatatypeInterface;
	value_file: fromDatatype.VarcharDatatypeInterface;
	value_text: fromDatatype.TextDatatypeInterface;
	value_array: fromDatatype.VarcharArrayDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeClass;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  user_submitted_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cpcommerce_form_answer_link_RowClass implements bl_cpcommerce_form_answer_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  form_field_set_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeClass;
  value_boolean: boolean;
  tpy_sync_switch: boolean;
	value_datetime: fromDatatype.TimestampTzDatatypeInterface;
	value_json: fromDatatype.JsonDatatypeInterface;
	value_file: fromDatatype.VarcharDatatypeInterface;
	value_text: fromDatatype.TextDatatypeInterface;
	value_array: fromDatatype.VarcharArrayDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeClass;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  user_submitted_guid: fromDatatype.GuidDataFieldInterface;
}


